import { formulas } from '../data/formulas';
import type { FormulaEntry } from '../types/formula';

export default function GenerateFormulas() {
  function groupFormulas(formulas: FormulaEntry[]) {
    return formulas.reduce<Record<string, FormulaEntry[]>>((acc, f) => {
      if (!acc[f.category]) acc[f.category] = [];
      acc[f.category]!.push(f);
      return acc;
    }, {});
  }

  const grouped = groupFormulas(formulas);

  function handleFocus(e: React.FocusEvent<HTMLElement>) {
    const selection = window.getSelection();
    const range = document.createRange();

    range.selectNodeContents(e.currentTarget);
    selection?.removeAllRanges();
    selection?.addRange(range);
  }

  function handleUnfocus(e: React.FocusEvent<HTMLElement>) {
    const selection = window.getSelection();
    const range = document.createRange();

    range.selectNodeContents(e.currentTarget);
    selection?.removeAllRanges();
  }

  return (
    <div className="pdf-like">
      <h1>Matematičke formule</h1>
      <p tabIndex={0} className='formula-info'>Kretanje kroz formule omogućeno je tipkom Tab.<br/>Kada se fokus nalazi na formuli, sadržaj teksta se automatski označava te ga je moguće kopirati u međuspremnik prečacem tipki Ctrl + C.</p>
      {Object.entries(grouped).map(([category, items]) => (
        <section >
          <h2 tabIndex={0} onFocus={handleUnfocus}>{category}</h2>
          {items.map((f, i) => (
            <div>
              <p tabIndex={0} onFocus={handleFocus}>{f.latex}</p>
            </div>
          ))}
        </section>
      ))}
    </div>
  );
}